export const messages = {
  page: {
    title: {
      id: 'signup.AuthRep.VerifyIdentity.Page.Title',
      defaultMessage: 'First, we need to confirm your identity',
    },
    instruction: {
      id: 'signup.AuthRep.VerifyIdentity.Page.VerifyInformation',
      defaultMessage: 'To keep personal health information secure,'
         + ' we require that you verify your identity by entering your' +
         ' access PIN.',
    },
  },
  form: {
    pin: {
      id: 'signup.AuthRep.VerifyIdentity.Label.Pin',
      defaultMessage: 'PIN',
    },
  },
  helpText: {
    pin: {
      id: 'signup.AuthRep.VerifyIdentity.HelpText.Pin',
      defaultMessage: 'Provided by the patient\'s care team.',
    },
  },
  button: {
    next: {
      id: 'signup.AuthRep.VerifyIdentity.Button.Next',
      defaultMessage: 'Next',
    },
    cancel: {
      id: 'signup.AuthRep.VerifyIdentity.Button.Cancel',
      defaultMessage: 'Cancel',
    },
  },
};
